import React from "react";
const FirebaseClientInitializerContext = React.createContext();
const FirebaseClientInitializerContextProvider =
  FirebaseClientInitializerContext.Provider;
export {
  FirebaseClientInitializerContext,
  FirebaseClientInitializerContextProvider,
};
